import { PaymentMethods } from 'account/rapyd-payment-poc/constants';
import { PaymentMethodType } from 'core/enums/payment-method';
import { RapydEmbeddedResponse } from 'core/services/api/payment/payment-rapyd';
import { PaymentRequestType } from './payment-request';

const RapydToolkitBody = {
  pay_button_text: 'Pay now',
  pay_button_color: '#0095da',
  style: {
    submit: {
      base: {
        borderRadius: '23.5px',
      },
    },
  },
};

export interface EmbeddedIframeResponseResolution {
  isLoading: boolean
}

export class PaymentRequestRapydEmbedded implements PaymentRequestType<RapydEmbeddedResponse> {
  constructor(private request: any) { }

  addValues(values: { [key: string]: number | string | undefined }) {
    this.request = {
      ...this.request,
      ...values
    }
    return this;
  }

  getDependantValues() {
    return Promise.resolve(this)
  }

  toPaymentRequestObject() {
    const { currencyCode, customerNumber, amount, paymentMethod, successReturnURL, failureReturnURL } = this.request;
    const successReturnUrlOverride = successReturnURL?.includes('local') ?
    "https://unificationdev.azurewebsites.net/en-za/mydstv-residential#/account/view-balance?payRes=success" : successReturnURL;
    const failureReturnUrlOverride = failureReturnURL?.includes('local') ?
     'https://unificationdev.azurewebsites.net/en-za/mydstv-residential#/account/view-balance?payRes=failure' : failureReturnURL;

    return {
      amount: `${amount}`,
      currency: currencyCode,
      country: paymentMethod === PaymentMethodType.DebitOrder ? 'ZA' : 'GB',
      payment_method_types_include:
        paymentMethod === PaymentMethodType.DebitOrder ? PaymentMethods.DebitOrder : PaymentMethods.CreditCard,
      metadata: {
        customer_number: customerNumber,
      },
      complete_payment_url: successReturnUrlOverride,
      error_payment_url: failureReturnUrlOverride,
    } as any;
  }

  toTokenRequestObject() {
    return this.toPaymentRequestObject()
  }

  handleResponse(response: RapydEmbeddedResponse) {
    const toolkit = new window.RapydCheckoutToolkit({ ...RapydToolkitBody, id: response.id });
    toolkit.displayCheckout();

    const successHandler = (event: any) => {
      const { redirect_url } = event.detail;
      window.location.assign(redirect_url);
      clear();
    };
    const failureHandler = () => {
      window.location.assign(this.request.failureReturnURL);
      clear();
    };
    const clear = () => {
      window.removeEventListener('onCheckoutPaymentSuccess', successHandler);
      window.removeEventListener('onCheckoutPaymentFailure', failureHandler);
    }

    window.addEventListener('onCheckoutPaymentSuccess', successHandler);
    window.addEventListener('onCheckoutPaymentFailure', failureHandler);
    return Promise.resolve({ isLoading: false })
  }
}